export const LOGIN_URL = "user/authenticate";
export const REFRESH_TOKEN_URL = "user/refreshtoken";
export const REGISTRATION_URL = "user/register";
export const registerOtpValidateUrl = "user/register/validateotp";
export const RESET_PASSWORD_URL = "user/resetpassword";
export const VALIDATE_OTP_URL = "user/validateotp";
export const SAVE_PASSWORD_URL = "user/savepassword";
export const ALL_AVATAR_URL = "user/portfolio/avatars";
export const UPLOAD_PROFILE_PIC_URL = "user/portfolio/profilepic";
export const ALL_COLOR_PALETTE_URL = "user/portfolio/colorsplate";
export const ALL_THEME_PALETTE_URL = "user/portfolio/colorstheme";
export const ALL_PROFILE_COLOR_URL = "user/portfolio/profilecolor";
export const SEARCH_INSTITUTION_URL = "search/institution";
export const SAVE_PROFILE_URL = "user/saveprofile";
export const CREATE_OTP_URL = "user/createotp";

export const UPDATE_USERINFO_URL = "user/portfolio/saveuserinfo";
export const UPDATE_EDUCATION_DETAILS_URL =
  "user/portfolio/saveeducationdetails";
export const UPDATE_PUBLICATION_URL = "user/portfolio/savepublication";
export const UPDATE_EXTRACARICULAM_URL = "user/portfolio/saveextracariculam";
export const UPDATE_DOCUMENTS_URL = "user/portfolio/savedocuments";
export const UPDATE_PROFILEPIC_URL = "/user/portfolio/profilepic";
export const GET_USERINFO_URL = "user/portfolio/userinfo";
export const GET_EDUCATION_DETAILS_URL = "user/portfolio/educationdetails";
export const GET_PUBLICATION_URL = "user/portfolio/publication";
export const GET_EXTRACARICULAM_URL = "user/portfolio/extracariculam";
export const GET_DOCUMENTS_URL = "user/portfolio/documents";
export const GET_USER_MENU_LIST_URL = "user/menu/menulist";
export const GET_USER_TYPE_LIST_URL = "user/userstype";

export const DASHBOARD_APPROVAL_HEADER_URL = "global/dashboard/approval/header";
export const DASHBOARD_APPROVAL_LIST_URL = "global/dashboard/approval/list";
export const DASHBOARD_BUTTON_LIST_URL =
  "global/dashboard/activityroledashboard";
export const DASHBOARD_ACTIVITY_LIST_URL = "global/dashboard/latestactivity";
export const DASHBOARD_TODO_LIST_URL = "global/todolist/todolist";
export const DASHBOARD_TODO_LIST_DUE_DATE_URL = "global/todolist/duedate";
export const DASHBOARD_SAVE_TODO_URL = "global/todolist/createedittodo";
export const DASHBOARD_DELETE_TODO_URL = "global/todolist/deletetodo";

export const getTaskUserDetailsUrl = "task/userdetails";
export const USER_LIST_BY_TASK_URL = "task/assginee";
export const GET_TASK_USER_RATING_URL = "task/userrating";
export const GET_TASK_USER_SCORE_URL = "task/userscore";
export const UPDATE_USER_LIST_BY_TASK_URL = "task/assignee/update";
export const USER_URL = "project/user";

// Project
export const PROJECT_APPLICANTS_SNAPSHOT_URL = "project/applicant/list";
export const DASHBOARD_URL = "project/data";
export const PROJECT_TABLE_USERSAVE_URL = "project/tabledatasave";
export const PROJECT_HEADERS_URL = "project/headers";
export const PROJECT_CLEAR_FILTER_SEARCH_URL = "project/filtersearchstateclear";
export const PROJECT_APPLICATION_STAGE_URL = "project/projectdetails";
export const PROJECT_FILTER_LIST_URL = "project/tablefilterfield";
export const PROJECT_ACTION_LIST_URL = "project/activities";
export const LIST_COLUMN_URL = "project/editcolumnfields";
export const GET_QUESTION_LIST_BY_PROJECT_URL = "project/question/list";
export const GET_OPERATOR_LIST_BY_PROJECT_QUESTIONS_URL =
  "project/question/operator";
export const GET_VALUES_LIST_BY_PROJECT_QUESTIONS_URL =
  "project/question/values";
export const UPDATE_COLUMN_URL = "config/tableeditcolumn";
export const GET_PROJECT_SETTINGS_URl = "project/filtersearchstate";
export const GET_PROJECT_USER_LIST_URL = "project/applicants";
export const EXPORT_PROJECT_URL = "project/generateexcel";

// Global
export const GLOBAL_SEARCH_URL = "global/search/globalsearch";
export const getGlobalASSearchListUrl = "global/advancesearch/searchby";
export const getGlobalASFilterListUrl =
  "global/advancesearch/filterfield/latest";
export const getGlobalASFilterDetailsUrl =
  "global/advancesearch/filterfield/fielddetails";
export const getGlobalASFilterResultUrl = "global/filter/data";
export const getGlobalSkillsUrl = "global/skills";
export const GLOBAL_FILE_UPLOAD_URL = "file/attachment";
export const GLOBAL_QUESTION_LIST_URL = "global/question/list";
export const ALL_PROJECT_LIST_URL = "project/all";
export const exportGlobalFilterResultUrl = "global/filter/data/generateexcel";
export const getGlobalLanguageListUrl = "global/language";

export const createGlobalDataUrl = "global/data/create";
export const updateGlobalDataUrl = "global/data/update";
export const getGlobalDataListUrl = "global/data/datalist";
export const getGlobalDataDetailsUrl = "global/data/details";
export const deleteGlobalDataUrl = "global/data/delete";

export const GET_USER_DETAILS_URL = "user/details";
export const GET_USER_LIST_URL = "user/list";
export const getUserProfileDetailsUrl = "user/userprofile";
export const getUserProfileDetailsByIdUrl = "user/userprofilebyid";
export const getUserProfileCompletionUrl = "user/userprofile/completion";
export const saveUserProfileUrl = "user/userprofile/save";
export const deleteUserProfileUrl = "user/userprofile/delete";

export const APPLICATION_OVERVIEW_URL = "task/overviewdetails";
export const APPLICATION_DETAILS_UPDATE_URL = "task/datasave";
export const APPLICATION_ACTIVITY_URL = "task/activityrole";
export const APPLICATION_DOCUMENTS_URL = "task/documents";
export const APPLICATION_FILE_RENAME_URL = "task/filerename";
export const APPLICATION_FILE_DELETE_URL = "task/filedelete";
export const APPLICATION_FILE_UPLOAD_URL = "task/upload";
export const UPDATE_APPLICATION_FILE_NAME_URL =
  "task/question/attachment/name/update";
export const UPDATE_APPLICATION_FILE_URL = "task/question/attachment/update";
export const APPLICATION_CHAT_LIST_URL = "task/chat";
export const APPLICATION_LOGS_URL = "task/logdetails";
export const APPLICATION_TIMELINE_URL = "task/newtimeline";
export const APPLICATION_EMAILS_URL = "email/list";
export const SPECIFIC_APPLICANT_DETAILS = "task/user/userinfo";
export const REPLY_COMMENT_URL = "task/updatechatdetails";
export const UPDATE_APPLICATION_CHAT_URL = "task/chatupdate";
export const UPDATE_TASK_DECISION_URL = "task/decision/update";
export const UPDATE_TASK_MULTISELECT_URL = "task/multiselect/update";
export const UPDATE_MULTIPLE_TASK_DECISION_URL = "task/decision/updatemultiple";
export const UPDATE_MULTIPLE_TASK_DOCUMENT_URL = "task/docupload/multiple";
export const UPLOAD_TASK_URL = "task/file/attachment";
export const createTaskOfferUrl = "task/offer/sent";
export const createTaskEmailUrl = "task/email/sent";

export const getAutoCompleteSearchListUrl = "autosearch/search";

export const GET_APPLICANT_OVERVIEW_DETAILS_URL = "user/overview/details";
export const GET_APPLICANT_OVERVIEW_DOCUMENTS_URL = "user/overview/documents";
export const GET_APPLICANT_OVERVIEW_EMAIl_URL = "user/overview/email";

// Email Inbox
export const GLOBAL_EMAIL_LIST_URL = "global/email/inbox/list";
export const APPLICATION_EMAIL_LIST_URL = "task/email/list";
export const GET_EMAIL_DETAILS_URL = "email/inbox/details";
export const CREATE_EMAIL_URL = "email/inbox/send";

// Email Template
export const GET_EMAIL_TEMPLATE_LIST_URL = "email/template/list";
export const GET_EMAIL_TEMPLATE_CATEGORY_LIST_URL = "email/template/category";
export const GET_EMAIL_TEMPLATE_LIST_BY_CATEGORY_URL =
  "email/template/category/details";
export const GET_EMAIL_TEMPLATE_DETAILS_URL = "email/template/details";
export const CREATE_EMAIL_TEMPLATE_URL = "email/template/create";
export const EDIT_EMAIL_TEMPLATE_URL = "email/template/edit";
export const COPY_EMAIL_TEMPLATE_URL = "email/template/copy";
export const DELETE_EMAIL_TEMPLATE_URL = "email/template/delete";

// Email Settings
export const GET_EMAIL_WORKFLOW_LIST_URL = "global/email/workflow/list";
export const GET_EMAIL_WORKFLOW_DETAILS_URL = "global/email/workflow/details";
export const CREATE_EMAIL_WORKFLOW_URL = "global/email/workflow/create";
export const UPDATE_EMAIL_WORKFLOW_URL = "global/email/workflow/update";
export const ALL_EMAIL_ROLE_LIST_URL = "email/allroles";
export const DELETE_EMAIL_WORKFLOW_URL = "global/email/workflow/delete";

export const ADD_NOTE_URL = "global/createnotes";
export const GET_ALL_NOTE_URL = "global/privatenotes";
export const DELETE_NOTE_URL = "global/deletenotes";
export const UPDATE_NOTE_URL = "global/updatenotes";

export const GET_GLOBAL_NOTIFICATIONS_LIST_URL = "global/notifications";
export const getGlobalNotificationCountApi = "global/notifications/total";
export const updateNotificationReadStatusApi = "global/notification/read";

export const ALL_TAG__URL = "global/tags";
export const TAG_LIST_BY_TASK__URL = "task/tags";
export const SCORES_BY_TASK__URL = "task/userscore";
export const TAG_UPDATE_BY_TASK_URL = "task/tags/update";
export const getTaskUniversityRankingListUrl = "task/universityranking";
export const getTaskDecisionUserListUrl = "task/decisionlist";

export const STUDENT_APPLICATIONS__URL = "user/app/applist";
export const getStudentAlertsUrl = "dashboard/notification";
export const getStudentAlertDetailsUrl = "dashboard/notification/details";
export const updateStudentOfferUrl = "applicant/offer/submit";

export const getCareerHubJobsFilterListUrl = "career/jobs/filterlist";
export const getCareerHubJobsListUrl = "career/jobs/jobslist/pagination";
export const getCareerHubJobsDetailsUrl = "career/jobs/jobdetails";
export const updateCareerHubSaveJobUrl = "career/jobs/savejob";

// Admin Settings
export const CREATE_STAGE_URL = "admin/stage/create";
export const UPDATE_STAGE_URL = "admin/stage/update";
export const GET_STAGE_LIST_URL = "admin/stage/list";
export const GET_ADMIN_PROJECT_STAGE_LIST_URL = "admin/project/stage/list";
export const DELETE_STAGE_URL = "admin/stage/delete";

export const CREATE_PROJECT_ATTRIBUTE_URL = "admin/project/attributes/create";
export const UPDATE_PROJECT_ATTRIBUTE_URL = "admin/project/attributes/update";
export const UPDATE_ATTRIBUTE_ACTION_URL =
  "admin/project/attributes/button/update";
export const UPDATE_ATTRIBUTE_FIELD_URL =
  "admin/project/attributes/field/update";
export const GET_PROJECT_ATTRIBUTE_LIST_URL = "admin/project/attributes/list";
export const GET_ADMIN_ATTRIBUTE_DETAILS_URL =
  "admin/project/attributes/details";
export const DELETE_PROJECT_ATTRIBUTE_URL = "admin/project/attributes/delete";

export const CREATE_ADMIN_ACTION_URL = "admin/button/create";
export const UPDATE_ADMIN_ACTION_URL = "admin/button/update";
export const DELETE_ADMIN_ACTION_URL = "admin/button/delete";
export const GET_ADMIN_ACTION_LIST_URL = "admin/button/list";

export const CREATE_ADMIN_FIELD_URL = "admin/field/create";
export const UPDATE_ADMIN_FIELD_URL = "admin/field/update";
export const DELETE_ADMIN_FIELD_URL = "admin/field/delete";
export const GET_ADMIN_FIELD_LIST_URL = "admin/field/list";

export const CREATE_ADMIN_ROLE_URL = "admin/role/create";
export const UPDATE_ADMIN_ROLE_URL = "admin/role/update";
export const DELETE_ADMIN_ROLE_URL = "admin/role/delete";
export const GET_ADMIN_ROLE_LIST_URL = "admin/role/list";

export const createAdminGroupUrl = "admin/group/create";
export const updateAdminGroupUrl = "admin/group/update";
export const deleteAdminGroupUrl = "admin/group/delete";
export const getAdminGroupListUrl = "admin/group/list";

export const ADMIN_ROLE_LIST_URL = "admin/roles";
export const ADMIN_PROJECT_LIST_URL = "admin/projectlist";
export const ADMIN_STAGE_LIST_URL = "admin/project/stages";
export const ADMIN_DEFAULT_FIELD_LIST_URL = "admin/role/project/defaultfields";
export const ADMIN_ROLE_FIELD_LIST_URL = "admin/role/project/fields";
export const ADMIN_ACTION_ADD_URL = "admin/role/project/button/add";
export const ADMIN_ACTION_UPDATE_URL = "admin/role/project/button/modify";
export const ADMIN_FIELD_ADD_URL = "admin/role/project/field/add";
export const ADMIN_FIELD_UPDATE_URL = "admin/role/project/field/modify";
export const ADMIN_ROLE_ADD_URL = "admin/roles/create";
export const ADMIN_ROLE_COPY_URL = "admin/roles/copy";
export const ADMIN_ROLE_RENAME_URL = "admin/roles/rename";
export const ADMIN_REMOVE_USER_URL = "admin/roles/user/remove";
export const ADMIN_ADD_USER_URL = "admin/roles/user/add";
export const ADMIN_ROLE_USER_LIST_URL = "admin/roles/user/userlist";

// Account Settings
export const GET_ACCOUNT_SETTING_MENU_LIST_URL = "user/setting/list";

// Invite Member
export const CREATE_INVITE_URL = "user/invite/send";
export const UPDATE_INVITE_URL = "user/invite/update";
export const GET_INVITE_LIST_URL = "user/invite/list";
export const DELETE_INVITE_URL = "user/invite/delete";

// Recommendation
export const getRecommendationTabListUrl = "global/dashboard/approval/tabs";
export const getRecommendationPositionListUrl =
  "recommendation/request/position";
export const getRecommendationListUrl = "global/dashboard/approval/tab/details";
export const createRecommendationUrl =
  "global/dashboard/recommendation/request";
export const getRecommendationDetailsUrl =
  "global/dashboard/recommendation/request/details";
export const creatReminderUrl = "global/dashboard/recommendation/reminder";

// Event
export const creatEventUrl = "event/create";
export const updateEventUrl = "event/edit";
export const copyEventUrl = "event/copy";
export const deleteEventUrl = "event/delete";
export const getEventTypeList = "event/eventType";
export const getEventTimeZoneList = "event/timezone";
export const getTrendingEventListUrl = "event/upcoming";
export const getCreatedByEventListUrl = "event/user/createdby";
export const getRegisteredEventListUrl = "event/user/registered";
export const getEventDetailsUrl = "event/details";
export const registerForEventUrl = "event/user/register";
export const interestForEventUrl = "event/interested";

// OfferLetter
export const createOfferLetterUrl = "offerletter/create";
export const updateOfferLetterUrl = "offerletter/edit";
export const copyOfferLetterUrl = "offerletter/copy";
export const getOfferLetterCategoryListUrl = "offerletter/type";
export const getOfferLetterListByCategoryUrl = "offerletter/category/details";
export const getOfferLetterDetailsUrl = "offerletter/details";
export const deleteOfferLetterUrl = "offerletter/delete";

// Public APIs
export const createContactUsUrl = "guest/request/contactus";
export const CREATE_GUEST_SUBSCRIBE_URL = "guest/request/emailregister";

export const campaignTrackUrl = "noauth/campaign/track";

export const getJobsPopularCategoryUrl = "noauth/jobs/popularcategory";
export const getJobsTestimonialUrl = "noauth/testimonial";
export const getJobsListUrl = "noauth/career/jobs/jobslist/pagination";
export const getJobsDetailsUrl = "noauth/career/jobs/jobdetails";
export const getJobsFilterListUrl = "noauth/career/jobs/filterlist";

export const CHATBOT_MESSAGE_URL = "ai/channel/message";

export const getOrgListUrl = "organization/orglist";
export const getOrgJobDetailsUrl = "organization/orgjob/details";
export const saveOrgJobUrl = "organization/orgjob/save";

export const createRulesFolderUrl = "rules/folder/new";
export const updateRulesFolderUrl = "rules/folder/edit";
export const deleteRulesFolderUrl = "rules/folder/delete";
export const getRulesFolderListUrl = "rules/folder/folders";
export const getRulesListUrl = "rules/folder/rules/list";
export const createRulesUrl = "rules/rule/new";
export const updateRulesUrl = "rules/rule/update";
export const getRulesDetailsUrl = "rules/rule/details";
export const deleteRulesUrl = "rules/rule/delete";
export const getRulesTenantListUrl = "rules/folder/rules/tenants";
export const getRulesTriggerListUrl = "rules/folder/rules/trigger";
export const getRulesActionTypeListUrl = "rules/folder/rules/actiontype";
export const getRulesActionValueSourceListUrl =
  "rules/folder/rules/actionvaluesource";

export const CREATE_FORM_URL = "formbuilder/form/save";
export const SETTING_FORM_URL = "formbuilder/question/savesetting";
export const VIEW_SETTING_URL = "formbuilder/question/setting";
export const VIEW_DROPDOWN_URL = "formbuilder/setting/dropdownlist";
export const VIEW_KEYVALUE_URL = "formbuilder/setting/dropdownvalue";

export const FORM_BUILDER_FOLDER_LIST_URL = "formbuilder/user/folders";
export const FORM_BUILDER_FOLDER_ADD_URL = "formbuilder/user/folder/new";
export const FORM_BUILDER_FORM_LIST_URL = "formbuilder/user/folder/forms";
export const FORM_BUILDER_FORM_ADD_URL = "formbuilder/user/form/newform";
export const FORM_BUILDER_FORM_EDIT_URL = "formbuilder/user/form/editform";
export const FORM_BUILDER_FORM_MULTIPLE_EDIT_URL =
  "formbuilder/user/form/dashbaord/updatemultiple";
export const FORM_BUILDER_FORM_DUPLICATE_URL =
  "formbuilder/user/form/duplicate";
export const FORM_BUILDER_FORM_COVER_IMAGE_URl =
  "formbuilder/user/form/coverimages";
export const FORM_BUILDER_FORM_COLLABORATOR_URL = "form/collaborator";
export const FORM_BUILDER_FORM_UPDATE_COLLABORATOR_URL =
  "form/collaborator/update";
export const FORM_BUILDER_FORM_SETTINGS_SAVE_URL =
  "formbuilder/form/savesetting";
export const FORM_BUILDER_FORM_INSTRUCTION_URL =
  "formbuilder/form/forminstruction";
export const FORM_BUILDER_FORM_DETAILS_URL = "formbuilder/form/formdetails";
export const FORM_BUILDER_FORM_APPLICATION_URL = "form/application/submit";
export const FORM_BUILDER_FORM_AUTO_SAVE_URL = "form/application/save";
export const FORM_BUILDER_FORM_APP_SUBMIT_URL = "form/application/data";
export const FORM_BUILDER_DATE_VALIDATE_URL = "form/validation/date";
export const NO_AUTH_FORM_BUILDER_FORM_DETAILS_URL = "noauth/form/formdetails";
export const NO_AUTH_FORM_BUILDER_FORM_APPLICATION_URL =
  "noauth/form/application/submit";
export const NO_AUTH_FORM_BUILDER_FORM_AUTO_SAVE_URL =
  "noauth/form/application/save";
export const NO_AUTH_FORM_BUILDER_FORM_APP_SUBMIT_URL =
  "noauth/form/application/data";
export const NO_AUTH_FORM_BUILDER_DATE_VALIDATE_URL =
  "noauth/form/validation/date";

export const CREATE_FORM_APPLICATION_URL = "application/form/save";
export const FORM_BUILDER_FORM_DETAILS_APPLICATION_URL =
  "application/form/formdetails";

export const FORM_BUILDER_MAP_FILLED_URL = "formbuilder/form/database/object";

export const FORM_BUILDER_TO_DATA_SOURCE =
  "formbuilder/form/database/object/fields";

export const FORM_BUILDER_AUTOSEARCH_URL = "autosearch/search";

export const FORM_BUILDER_AUTOSEARCH_LIST_URL = "autosearch/list";

export const FORM_BUILDER_AUTOSEARCH_EVENT_URL = "autosearch/event";

export const UPLOAD_FORM_FILE_URL = "form/file/attachment ";

export const EMAIL_SAVE_TEMPLATE = "email/dragdrop/email/save";

export const EMAIL_SAVE_SETTING = "email/dragdrop/question/savesetting";

export const EMAIL_GET_TEMPLATE = "email/dragdrop/emaildetails";

export const EMAIL_GET_SETTING = "email/dragdrop/question/setting";

export const FORM_BUILDER_FORM_DETAILS_URL_LATEST =
  "formbuilder/form/formdetails/latest";

export const CREATE_FORM_URL_LATEST = "formbuilder/form/save/latest";

export const FORM_BUILDER_GLOBAL = "formbuilder/global/field";

export const WORKFLOWS_CREATE_FOLDER_API = "workflow/user/folder/new";

export const WORKFLOWS_GET_FOLDER_LIST_API = "workflow/user/folders";

export const WORKFLOWS_GET_WORKFLOW_PER_FOLDER_API =
  "workflow/user/folder/workflows";

export const WORKFLOWS_CREATE_WORKFLOW_API = "workflow/user/workflow/new";

export const WORKFLOWS_DETAILS_WORKFLOW_API = "workflow/user/workflow/details";

export const WORKFLOWS_ADMIN_PDF_API = "admin/pdftemplate/list";

export const WORKFLOWS_ADMIN_STATUS_API = "admin/status/list";

export const WORKFLOWS_SAVE_SETTING_API =
  "workflow/user/workflow/eventsetting/save";

export const WORKFLOWS_GET_SETTING_API =
  "workflow/user/workflow/eventsetting/details";

export const WORKFLOWS_SAVE_WORKFLOW_API = "workflow/user/workflow/save";

export const WORKFLOWS_PUBLISH_WORKFLOW_API = "workflow/user/workflow/publish";
